
































import {Component, Vue, Watch} from "vue-property-decorator";
import {getToken} from "@/store/modules/auth/getters";
import {Getter, Action} from "vuex-class";
import AuthService from "@/service/AuthService";
import LoginForm from "@/components/Auth/LoginForm.vue";
import i18n from "@/locales/index"
import DefaultLayout from "@/layouts/DefaultLayout.vue";


const authNamespace: string = "auth";
@Component({
  components: {DefaultLayout, LoginForm}
})
export default class Login extends Vue {

  public name: string = "Login";

  @Action('login', {namespace: authNamespace})
  private login: any;

  @Getter("getToken", {namespace: authNamespace})
  protected getToken: any;

  private redirectUrl: any = '';

  private error: any = null;

  public onSubmit(credentials: object): void {
    this.login(credentials).then((response: any) => {
    }).catch((error: any) => {
      // removed console_log
      this.error = error.data;
    });

  }

  private onChange(): void {

    this.error = null;

  }

  private errormsg(): string {

    return this.error && this.error.error === true ? this.error.message : '';

  }

  mounted() {

    this.redirectUrl = this.$route.query.redirectUrl;

  }

}
